import React from 'react';

/**
 * @param {string|null} callerInfo — caller display (required to show banner)
 * @param {string|null} [lineInfo] — dialed line, only when this user may use that DID
 */
export default function IncomingCall({ callerInfo, callerName, lineInfo, onAccept, onReject }) {
  if (!callerInfo) return null;

  return (
    <div className="incoming-call-banner">
      <div className="incoming-banner-info">
        <span className="incoming-banner-label">
          {lineInfo ? `📞 On ${lineInfo}` : '📞 Truva Audio...'}
        </span>
        <span className="caller-id">{callerName || callerInfo}</span>
        {callerName && <span className="incoming-banner-label">{callerInfo}</span>}
      </div>
      <div className="incoming-actions">
        <button className="btn-reject" onClick={onReject} aria-label="Decline">
          ✕
        </button>
        <button className="btn-accept" onClick={onAccept} aria-label="Accept">
          ✓
        </button>
      </div>
    </div>
  );
}
